import { Layout } from "antd";
import styled from "styled-components";
const { Content } = Layout;

export const ContentContainer = styled(Content)`
    overflow: initial;
    flex: 1;
`